import { render, staticRenderFns } from "./CarStats.vue?vue&type=template&id=73330577&"
import script from "./CarStats.vue?vue&type=script&lang=js&"
export * from "./CarStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports